module.exports = __webpack_public_path__ + "img/default-list.63420141.png";